import { cpf, cnpj } from 'cpf-cnpj-validator'
import * as yup from 'yup'

export type TipoPessoa = 'PF' | 'PJ'

export const createPropertySchema = (tipoPessoa: TipoPessoa) =>
  yup.object().shape({
    descricao: yup.string().required('Nome da Fazenda é obrigatório').typeError('Campo obrigatório'),
    proprietario: yup.string().required('Proprietário é obrigatório').typeError('Campo obrigatório'),
    razao: yup.string().required('Razão Social é obrigatório').typeError('Campo obrigatório'),
    documento: yup
      .string()
      .required(tipoPessoa === 'PF' ? 'CPF é obrigatório' : 'CNPJ é obrigatório')
      .test(
        'is-valid-document',
        tipoPessoa === 'PF' ? 'CPF inválido' : 'CNPJ inválido',
        (value) => {
          if (!value) return false
          const clean = value.replace(/\D/g, '')
          return tipoPessoa === 'PF' ? cpf.isValid(clean) : cnpj.isValid(clean)
        }
      ),
    endereco: yup.string().required('Endereço é obrigatório').typeError('Campo obrigatório'),
    estado: yup.string().required('Estado é obrigatório').typeError('Campo obrigatório'),
    cidade: yup.string().required('Cidade é obrigatório').typeError('Campo obrigatório')
  })

const schema = createPropertySchema('PJ')

export default schema
